module.exports = __webpack_public_path__ + "img/پاکت--گلاسه.ed3d4b1a.png";